/**
 * Wraps an API/axios error so callers can use try/catch or .catch() and show error state.
 * Use extractApiError(error) to get a user-facing message (it unwraps ApiError.cause).
 */
export class ApiError extends Error {
  constructor(public readonly cause: unknown) {
    const message =
      cause instanceof Error ? cause.message : String(cause ?? "API error");
    super(message);
    this.name = "ApiError";
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
